@if (available.length > 0) {
  <div>
    <cpq-multi-list-box-with-selection #cpqMultiListBox [isCpqPermissions]='true' [labelAvailable]="{key: 'Admin.CpqPermission.AvailablePermissionGroups'}" [labelSelected]="{key: 'Admin.CpqPermission.SelectedPermissionGroups'}"
      [available]='available' [selected]='selectedPermissionGroups' [blockedItems]='blockedItems' (onSelect)='onSelect($event)' (onRemove)='onRemove($event)'>
    </cpq-multi-list-box-with-selection>
  </div>
}
